/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import { SidebarGlobal } from "../_SidebarGlobal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import Globals from "../../shared/Globals";
import React from "react";
import ScrollHandler from "../ScrollHandler";
import LoadingAlert from "../LoadingAlert";
import Alert from "../Alert";
import Tick from "../Tick";
import Auth from "../../shared/Auth";
import FormInput from "../FormInput";
import AppActions from "../AppActions";
import L from "../Lang";

class Inventory extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            page: 1,
            pageSize: 30,
            eol: false,
            statuses: [],
            filter: {},
            count: 0,
            tmp: {
                isInvoiced: 'null'
            }
        };
        this.fileRef = React.createRef();
    }

    async componentDidMount() {
        await this.load();
        await this.fillListAsync('/api/inventory/status/list', 'statuses');
        await this.fillListAsync('/api/account/list', 'accounts');
        await this.loadProducts();

    }

    loadProducts = async () => {
        try {
            let j = await qreq.postAsync('/api/product/list', {});
            if (j.list) {
                j.list.sort((a, b) => {
                    let za = a.productName + ' ' + a.productSize;
                    let zb = b.productName + ' ' + b.productSize;
                    return za.localeCompare(zb);
                });
                j.list.forEach(i => {
                    i.name = i.name + ' ' + i.productSize;
                });
                this.setState({ products: j.list });
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async (sort, page, search, filter) => {
        if (!page) page = 1;
        this.setState({ loading: true });
        try {
            let j = await qreq.getAsync('/api/inventory/list?sort=' + (sort?.name || 'createdDate')
                + '&asc=' + (sort?.asc ? 'true' : 'false')
                + '&page=' + page
                + '&pageSize=' + this.state.pageSize
                + (search ? '&search=' + encodeURIComponent(search) : '')
                + (filter?.status ? '&status=' + encodeURIComponent(filter.status) : '')
                + (filter?.productID ? '&productID=' + encodeURIComponent(filter.productID) : '')
                + (filter?.receivedDateStart ? '&receivedDateStart=' + encodeURIComponent(Globals.toDateOnlyString(filter.receivedDateStart)) : '')
                + (filter?.receivedDateEnd ? '&receivedDateEnd=' + encodeURIComponent(Globals.toDateOnlyString(filter.receivedDateEnd)) : '')
                + (filter?.accountID ? '&accountID=' + encodeURIComponent(filter.accountID) : '')
                + (filter?.isInvoiced ? '&isInvoiced=' + encodeURIComponent(filter.isInvoiced) : '')
            );
            if (j.list) {
                if (page === 1)
                    this.setState({ list: j.list, count: j.totalCount });
                else
                    this.setState({ list: this.state.list.concat(j.list) });
                if (j.list.length < this.state.pageSize)
                    this.setState({ eol: true });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback();
        }
        setTimeout(() => this.setState({ loading: false }), 1000);

    }

    refresh = async () => {
        await this.load(this.state.sort, this.state.page, this.state.search, this.state.filter);
    }

    triggerImport = () => {
        this.fileRef.current.click();
    }

    import = async (e) => {
        this.setState({ uploading: true });
        try {
            let file = e.target.files[0];
            let formData = new FormData();
            formData.append('file', file);
            let j = await qreq.postformAsync('/api/inventory/import', formData);
            if (j.errorCode === 0) {
                this.success(`Inserted ${j.item.inserted} items, ${j.item.updated} items exist. Catalog code not found ${j.item.noProduct}. Total in file: ${j.item.total}.`);
                this.load();
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            this.unkownErrorCallback();
        }
        e.target.value = null;
        this.setState({ uploading: false });
    }

    sort = (col) => {
        this.setState({ sort: col, eol: false });
        this.load(col, null, this.state.search, this.state.filter);
    }

    search = (e) => {
        this.setState({ newSearch: e.target.value });
    }

    searchTick = () => {
        let newSearch = this.state.newSearch;
        if (this.state.search !== newSearch) {
            let page = 1;
            this.setState({ search: newSearch, page: page, eol: false });
            this.load(this.state.sort, page, newSearch, this.state.filter);
        }
    }

    nextPage = () => {
        if (this.state.eol) return;
        let page = this.state.page + 1;
        this.load(this.state.sort, page, this.state.search, this.state.filter);
        this.setState({ page: page });
    }

    filterStatus = async (v) => {
        let filter = { ...this.state.filter, status: v };
        this.setState({ filter: filter, eol: false });
        await this.load(this.state.sort, 1, this.state.search, filter);
    }

    filterProduct = async (v) => {
        let filter = { ...this.state.filter, productID: v };
        this.setState({ filter: filter, eol: false });
        await this.load(this.state.sort, 1, this.state.search, filter);
    }

    showFilterByReceivedDate = () => {
        this.setState({ filterByReceivedDate: true });
        this.filterDateRange([new Date(), new Date()]);
    }

    filterDateRange = async (v) => {
        let filter = {};
        if (!v || !v[0] || !v[1]) {
            filter = { ...this.state.filter, receivedDateStart: null, receivedDateEnd: null };
            this.setState({ filterByReceivedDate: false });
        }
        else
            filter = { ...this.state.filter, receivedDateStart: v[0], receivedDateEnd: v[1] };
        this.setState({ filter: filter, eol: false });
        await this.load(this.state.sort, 1, this.state.search, filter);
    }

    filterAccount = async (v) => {
        let filter = { ...this.state.filter, accountID: v };
        this.setState({ filter: filter, eol: false });
        await this.load(this.state.sort, 1, this.state.search, filter);
    }

    filterIsInvoiced = async (v) => {
        let filter = { ...this.state.filter, isInvoiced: v };
        this.setState({ filter: filter, eol: false });
        await this.load(this.state.sort, 1, this.state.search, filter);
    }

    export = () => {
        let filter = this.state.filter;
        let search = this.state.search;
        let sort = this.state.sort;
        console.log(Globals.serverUrl + '/api/inventory/export/?sort='
            + (sort?.name || 'createdDate')
            + '&asc=' + (sort?.asc ? 'true' : 'false')
            + (search ? '&search=' + encodeURIComponent(this.state.search) : '')
            + (filter?.status ? '&status=' + encodeURIComponent(filter.status) : '')
            + (filter?.productID ? '&productID=' + encodeURIComponent(filter.productID) : '')
            + (filter?.receivedDateStart ? '&receivedDateStart=' + encodeURIComponent(Globals.toDateOnlyString(filter.receivedDateStart)) : '')
            + (filter?.receivedDateEnd ? '&receivedDateEnd=' + encodeURIComponent(Globals.toDateOnlyString(filter.receivedDateEnd)) : '')
            + (filter?.accountID ? '&accountID=' + encodeURIComponent(filter.accountID) : '')
            + (filter?.isInvoiced ? '&isInvoiced=' + encodeURIComponent(filter.isInvoiced) : ''));
        window.open(Globals.serverUrl + '/api/inventory/export/?sort='
            + (sort?.name || 'createdDate')
            + '&asc=' + (sort?.asc ? 'true' : 'false')
            + (search ? '&search=' + encodeURIComponent(this.state.search) : '')
            + (filter?.status ? '&status=' + encodeURIComponent(filter.status) : '')
            + (filter?.productID ? '&productID=' + encodeURIComponent(filter.productID) : '')
            + (filter?.receivedDateStart ? '&receivedDateStart=' + encodeURIComponent(Globals.toDateOnlyString(filter.receivedDateStart)) : '')
            + (filter?.receivedDateEnd ? '&receivedDateEnd=' + encodeURIComponent(Globals.toDateOnlyString(filter.receivedDateEnd)) : '')
            + (filter?.accountID ? '&accountID=' + encodeURIComponent(filter.accountID) : '')
            + (filter?.isInvoiced ? '&isInvoiced=' + encodeURIComponent(filter.isInvoiced) : '')
            , '_blank');

    }

    render() {
        SidebarGlobal.setSubNav(Auth.hasRole('manager') && <>
            <Link to="/inventory/new" className="btn btn-primary"><Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>New</L></span></Link>
            <button className={'btn btn-secondary' + (this.state.loading ? ' highlighted' : '')} onClick={this.refresh}>
                <Icon icon="faRefresh" className={this.state.loading ? 'spinner' : ''} /> <span className="d-none d-md-inline"><L>Refresh</L></span>
            </button>
            <button className="btn btn-warning" onClick={this.triggerImport}><Icon icon="faFileUpload" /> <span className="d-none d-md-inline"><L>Import</L></span></button>
        </>);


        const columns = [
            { name: 'createdDate', title: 'Added On', valueFunc: row => <Link to={`/inventory/${row.id}`} title="View Item" className="text-dark">{Globals.toMDYLocalDateString(row.createdDate)}</Link>, className: 'd-none d-md-table-cell' },
            { name: 'productName', title: 'Product', valueFunc: row => <Link to={`/inventory/${row.id}`} title="View Item" className="text-dark">{row.productName} {row.isPricePerUnit && row.productSize}</Link> },
            { name: 'manufacturerName', title: 'Manufacturer', valueFunc: row => <Link to={`/inventory/${row.id}`} title="View Item" className="text-dark">{row.manufacturerName}</Link>, className: 'd-none d-md-table-cell' },
            { name: 'lotNumber', title: 'Lot Number', valueFunc: row => <Link to={`/inventory/${row.id}`} title="View Item" className="text-dark">{row.lotNumber}</Link> },
            { name: 'expirationDate', title: 'Expiration', valueFunc: row => <Link to={`/inventory/${row.id}`} title="View Item" className="text-dark">{Globals.toMDYDateString(row.expirationDate)}</Link> },
            {
                name: 'status', title: 'Status',
                valueFunc: row => {
                    let clazz = 'text-muted';
                    let status = row.status;
                    if (row.isAccountReceived) {
                        if (row.inStock) {
                            clazz = 'text-warning';
                            status = <><L>Returned by</L> <strong>{row.accountName}</strong></>;
                        }
                        else {
                            clazz = 'text-success';
                            status = <><L>Received by</L> <strong>{row.accountName}</strong></>;
                        }
                    }
                    else if (row.isSent) {
                        if (row.inStock) {
                            clazz = 'text-danger';
                            status = <><L>Returned by</L> <strong>{row.accountName}</strong></>;
                        }
                        else {
                            clazz = 'text-primary';
                            status = <><L>Sent to</L> <strong>{row.accountName}</strong></>;
                        }
                    }
                    else if (row.inStock)
                        clazz = 'text-default';
                    return <span className={clazz}>{status}</span>;
                },
                noSort: true
            },
            { name: 'receivedDate', title: 'Received', valueFunc: row => row.isReceived ? Globals.toMDYHMLocalDateStringOrDiff(row.receivedDate, true) : '', className: 'd-none d-md-table-cell' },
        ];

        return (
            <div className="container-fluid" style={{ overflow: 'visible', minHeight: '500px' }}>
                <h1><L>Inventory</L></h1>
                <input type="file" ref={this.fileRef} className="d-none" onChange={this.import} />
                <input type="text" className="form-control mb-1" onChange={this.search} placeholder="Search..." />
                <Tick onTick={this.searchTick} />
                <AppActions noBack>
                    <button type="button" className="d-block btn btn-secondary btn-lg" onClick={() => this.props.navigate('/menu')}>
                        <Icon icon="faBars" /> <L>Menu</L></button>
                    <button type="button" className="d-block btn btn-secondary btn-lg" onClick={this.export}>
                        <Icon icon="faFileExcel" /> <L>Export</L></button>
                </AppActions>
                <div className="my-2">
                    <div className="row align-items-center">
                        {Auth.hasRole('manager') && <div className="col-md-2">
                            <div className="input-group mb-3">
                                <select className="form-control" onChange={e => this.filterStatus(e.target.value)}>
                                    <option value=""><L>Filter by Status</L></option>
                                    {this.state.statuses.map(s => <option key={s} value={s}>{s}</option>)}
                                </select>
                            </div>
                        </div>}
                        <div className="col-md-2">
                            <div className="input-group mb-3">
                                <select className="form-control" onChange={e => this.filterProduct(e.target.value)}>
                                    <option value=""><L>Filter by Product</L></option>
                                    {this.state.products?.map(s => <option key={s.id} value={s.id}>{s.productName} {s.isPricePerUnit ? s.productSize : ''}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="input-group mb-3">
                                <select className="form-control" onChange={e => this.filterAccount(e.target.value)}>
                                    <option value=""><L>Filter by Account</L></option>
                                    {this.state.accounts?.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                                </select>
                            </div>
                        </div>
                        {Auth.hasRole('manager') && <div className="col-md">
                            <FormInput model={this.state.tmp}
                                name="isInvoiced"
                                label="Invoiced"
                                type="select"
                                options={[
                                    { id: 'true', name: 'Invoiced' },
                                    { id: 'false', name: 'Not Invoiced' },
                                ]}
                                selectDefault="Both"
                                labelAsPlaceholder
                                onChange={v => this.filterIsInvoiced(v)} />
                        </div>}
                        <div className="col-md-3">
                            <div className="input-group mb-3">
                                {!this.state.filterByReceivedDate &&
                                    <button type="button" className="btn btn-secondary"
                                        onClick={this.showFilterByReceivedDate}><L>Filter by Received Date</L></button>}
                                {this.state.filterByReceivedDate &&
                                    <FormInput model={this.state.tmp}
                                        labelAsPlaceholder
                                        name="receivedDate"
                                        type="daterange"
                                        label="Received Date"
                                        inputGroupClassName=" "
                                        onChange={v => this.filterDateRange(v)}
                                    />}
                            </div>
                        </div>

                        <div className="col-md">
                            There are {this.state.count} items.
                        </div>
                    </div>
                </div>

                <DataTable columns={columns} data={this.state.list} onSort={this.sort}
                    sticky heightDelta="345" scrollHandler={this.nextPage} footer={this.state.loading ? <LoadingAlert /> : this.state.eol && !this.state.loading && <Alert type="light"><L>End of list.</L></Alert>} />
            </div>
        );
    }
}

export default withParamsAndNavigate(Inventory);